import { Device } from '@/api/profile.api'

import { MapDevice } from '../types'

/** Jedyne przejście DTO → model prezentacyjny monitoringu. Backend dopuszcza
 *  `udtNumber: null` i `warningDays: null` — tu spłaszczamy to do kształtu,
 *  na którym komponenty mogą polegać bez własnych strażników.
 *  `resourceLabel` żyje w szablonie językowym urządzenia, a pole górnego
 *  poziomu jest tylko rezerwą dla starszych odpowiedzi API. */
export const toMapDevice = (device: Device, language?: string): MapDevice => {
  const template =
    device.deviceTemplates?.find((tpl) => tpl.language?.toUpperCase?.() === language?.toUpperCase()) ??
    device.deviceTemplates?.[0]

  return {
    id: device.id,
    name: device.name,
    serialNumber: device.serialNumber,
    udtNumber: device.udtNumber ?? '',
    latitude: device.latitude ?? undefined,
    longitude: device.longitude ?? undefined,
    resource: device.resource ?? undefined,
    resourceLabel: template?.resourceLabel ?? device.resourceLabel ?? undefined,
    inspections: device.inspections
      ?.filter((inspection) => inspection?.validityDate)
      .map((inspection) => ({
        validityDate: String(inspection.validityDate),
        warningDays: inspection.warningDays ?? undefined,
        inspectionDate: inspection.inspectionDate ? String(inspection.inspectionDate) : undefined,
      })),
  }
}
